import { GetStaticProps } from 'next';
import { useEffect } from 'react';
import { ClearInNavbar } from '../../../../components/Navbar/ClearNavbar';
import { b2cData } from '../../../../components/cms/layout/components/header';
import { ITR_DATA } from '../../../../components/income-tax/static/types';
import { ITR2Page } from '../../../../components/itr-filing-for-esop-and-rsu';
import {
  canonical,
  description,
  keywords,
  pageTitle,
} from '../../../../components/itr-filing-for-esop-and-rsu/static/constants';
import { itrData } from '../../../../components/itr-filing-for-esop-and-rsu/static/data';
import { Meta } from '../../../../layout/Meta';
import { FM_ACTIONS, returnNoProps } from '../../../../utils/UtilFunctions';
import { staticPropsWrapper } from '../../../../utils/static-pages/utils';
import { handleTrack } from '../../../../utils/tracker';
import { Schema } from '../../../../components/itr2/schema';

const ITR2 = (): JSX.Element => {
  useEffect(() => {
    if (window !== undefined) {
      window.parentCategory = 'itr-filing-for-esop-and-rsu';
      handleTrack({
        label: window.location.pathname,
        action: FM_ACTIONS.pageview,
      });
    }
  }, []);
  return (
    <div className="relative">
      <ClearInNavbar data={b2cData} showPlanVariant={'variantA'} />
      <Meta
        title={pageTitle}
        description={description}
        canonical={canonical}
        keywords={keywords}
        isItr={true}
      />
      <ITR2Page itrData={itrData as unknown as ITR_DATA} />
      <script type="application/ld+json">
        <Schema description={description} name={pageTitle} />
      </script>
    </div>
  );
};

export const getStaticProps: GetStaticProps = staticPropsWrapper(
  __filename,
  () => {
    return returnNoProps();
  }
);

export default ITR2;
